'use client';

import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  confirmText?: string;
  cancelText?: string;
}
export function ConfirmationModalCompact({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure you want to logout?",
  confirmText = "Logout",
  cancelText = "Cancel"
}: ConfirmationModalProps) {
  return <AlertDialog open={isOpen} onOpenChange={onClose} data-sentry-element="AlertDialog" data-sentry-component="ConfirmationModalCompact" data-sentry-source-file="confirm-modal-compact.tsx">
      <AlertDialogContent className="max-w-[400px] p-0 overflow-hidden rounded-xl" data-sentry-element="AlertDialogContent" data-sentry-source-file="confirm-modal-compact.tsx">
        <AlertDialogHeader className="p-6" data-sentry-element="AlertDialogHeader" data-sentry-source-file="confirm-modal-compact.tsx">
          <AlertDialogTitle className="text-center text-lg  py-4 mx-4 " data-sentry-element="AlertDialogTitle" data-sentry-source-file="confirm-modal-compact.tsx">
            {title}
          </AlertDialogTitle>
        </AlertDialogHeader>
        <div className="flex flex-col">
          <Button variant="ghost" className="text-red-500 hover:text-red-600 hover:bg-gray-50 rounded-none h-14 text-lg font-normal border-t" onClick={onConfirm} data-sentry-element="Button" data-sentry-source-file="confirm-modal-compact.tsx">
            {confirmText}
          </Button>
          <Button variant="ghost" className="rounded-none h-14 text-lg font-normal border-t text-gray-900 hover:bg-gray-50" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="confirm-modal-compact.tsx">
            {cancelText}
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>;
}